import React, { useContext, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Main.css'
import Header from '../Header/Header'
import StockAnalysisDisplayFilter from '../StockAnalysisDisplayFilter/StockAnalysisDisplayFilter'
import TimeFrameFilter from '../TimeFrameFilter/TimeFrameFilter'
import LowerStockPrice from '../PriceEvaluation/LowerStockPrice/LowerStockPrice'
import HigherStockPrice from '../PriceEvaluation/HigherStockPrice/HigherStockPrice'
import { StockContext} from '../Context/StockContext'
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom'
import StockDetails from '../PriceEvaluation/StockDetails/StockDetails';
import SubscriptionPlan from '../SubscriptionPlan/SubscriptionPlan';


const Home = () => {
  return (
    <div className='Main-Container'>
        <div className='TimeFrameFilter-Main'><TimeFrameFilter /></div>
        <div className='StockAnalysisDisplayFilter-Main'><StockAnalysisDisplayFilter/></div>
      <div className="LowerStockPrice-Main p-1 m-5">
        <h3 style={{color:'red'}}>Lower Priced Stocks - Bear Stocks</h3>
        <LowerStockPrice />
        </div>
        <div className="HigherStockPrice-Main p-1 m-4">
        <h3 style={{color:'green'}}>Higher Priced Stocks - Bull Stocks</h3>
        <HigherStockPrice />
        </div>
    </div>
  )
}


const Main = (props) => {

  const {setUser, user} = useContext(StockContext)

  useEffect(()=>{if(user===null) {setUser(props.user)} },[])
    
    // if(user !== null){console.log(user)}

  return(
    <div>
      <Router>
      <div className="Header-Main"><Header signOut={props.signOut}/></div>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/stock-details' element={<StockDetails/>}/>
          <Route path='/subscription' className='subscription-main-container' element={<SubscriptionPlan/>}/>
        </Routes>
      </Router>
    </div>
  )  

}

export default Main